import React from 'react';
import {
  CustomModal,
  CustomTable,
  FormInput,
  FormSelect,
  GeneralContainer,
} from '../../../../components';
import { Button, Col, Row } from 'antd';
import { FileDoneOutlined, ProfileOutlined } from '@ant-design/icons';
import type { ShareResponse } from '../../../../share';

interface Data {
  item: string;
  seccional: string;
  factura: string;
  cantidad: string;
}

interface ModalSeccionalProps {
  isOpen: boolean;
  formik: any;
  items: Data[];
  currentPage: number;
  sedes: ShareResponse[];
  totalCantidad: number;
  onPagination: (page: number) => void;
  onReset: () => void;
  handleDelete: (record: Data) => void;
  setIsOpen: (value: boolean) => void;
}

const PAGE_SIZE = 8;

const ModalSeccional = ({
  isOpen,
  formik,
  items,
  currentPage,
  sedes,
  totalCantidad,
  onReset,
  onPagination,
  handleDelete,
  setIsOpen,
}: ModalSeccionalProps) => {
  const columns = React.useMemo(
    () => [
      {
        title: 'Item',
        dataIndex: 'item',
        key: 'item',
        align: 'center',
      },
      {
        title: 'Seccional',
        dataIndex: 'name',
        key: 'name',
        align: 'center',
      },
      {
        title: 'Factura',
        dataIndex: 'factura',
        key: 'factura',
        align: 'center',
      },
      {
        title: 'Cantidad',
        dataIndex: 'cantidad',
        key: 'cantidad',
        align: 'center',
      },
      {
        title: 'Acciones',
        dataIndex: 'acciones',
        key: 'acciones',
        align: 'center',
        render: (_: any, record: Data) => (
          <Button
            type="default"
            style={{ backgroundColor: 'red', color: 'white' }}
            onClick={() => handleDelete(record)}
          >
            Eliminar
          </Button>
        ),
      },
    ],
    [items]
  );

  return (
    <CustomModal
      title="Añadir seccionales"
      open={isOpen}
      onCancel={() => {
        onReset();
      }}
      width="95vw"
      isLoadingSave={false}
      onClose={() => {
        setIsOpen(false)
      }}
      labelSubmit="Aceptar"
      onSave={() => setIsOpen(false)}
    >
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={8} lg={8}>
          <FormSelect
            label="Seccional entrada"
            name="section_id"
            placeholder="Seleccione"
            value={formik.values.section_id}
            options={(sedes || [])?.map((x) => ({
              name: `${x?.code} - ${x?.name}`,
              id: x?.id.toString(),
            }))}
            error={formik.errors.section_id}
            touched={formik.touched.section_id}
            onChange={(value: string) => {
              const option = sedes?.find((sede) => sede.id == value);
              formik.setFieldValue('section_id', value);
              formik.setFieldValue('section_label', option?.name);
            }}
            onBlur={() => formik.setFieldTouched('section_id', true)}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>

          <FormInput
            label="Número de: factura/oficio/peritaje/Doc. equivalente/Avalúo/Informe"
            name="invoice_number"
            placeholder="Inserte"
            value={formik.values.invoice_number}
            error={formik.errors.invoice_number}
            touched={formik.touched.invoice_number}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8}>
          <FormInput
            label="Cantidad"
            name="deliveries"
            placeholder="Seleccione"
            value={formik.values.deliveries}
            error={formik.errors.deliveries}
            touched={formik.touched.deliveries}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
              formik.setFieldValue('deliveries', val);
            }}
            onBlur={formik.handleBlur}
          />
        </Col>
      </Row>
      <Row gutter={[16, 16]} style={{ marginBottom: '20px' }}>
        <Col xs={24} sm={12} md={8} lg={6}>
          <Button type="default" icon={<ProfileOutlined />}>
            {`${totalCantidad} Entregas totales`}
          </Button>
        </Col>

        <Col xs={24} sm={12} md={8} lg={6}>
          <Button type="default" icon={<FileDoneOutlined />}>
            {`${items.length} Total facturas`}
          </Button>
        </Col>
      </Row>

      <GeneralContainer
        title="Seccionales de entrega"
        actionLabel="Añadir"
        onActionClick={() => {
          formik.handleSubmit();
        }}
      >
        <Row>
          <Col xs={24}>
            <CustomTable
              columns={columns as any}
              dataSource={items}
              paginationConfig={{
                current: currentPage,
                pageSize: PAGE_SIZE,
                total: items.length,
                onChange: onPagination,
              }}
              scroll={{ x: 'max-content' }}
            />
          </Col>
        </Row>
      </GeneralContainer>
    </CustomModal>
  );
};

export default ModalSeccional;